<template>
  <v-card flat>
    <v-row no-gutters class="pl-4">
      <v-col
        class="py-0 pa-2 pb-1"
        @click="handleBack"
        style="cursor: pointer"
        cols="12"
      >
        <span color="primary" class="no-hover" icon style="width: 18px">
          <v-icon
            class="body-bold-smaller color-back"
            size="12"
            height="12px"
            width="11px"
            >mdi-arrow-left</v-icon
          >
        </span>
        <span
          class="body-bold-smaller color-back"
          style="vertical-align: middle"
        >
          {{ $t('message.actions.return') }}
        </span>
      </v-col>
      <v-col>
        <div>
          <h3 class="body-bold-medium pl-2">Pixels</h3>
          <div class="pt-0 pl-2">
            <div>
              <div class="mb-3">
                <span class="body-regular-smaller color-description mb-0">
                  {{ $t('message.pages.videoPlayerPixels.descriptionPixels') }}
                </span>
                <a
                  target="_blank"
                  type="secondary"
                  class="neutral-30-base--text"
                  :href="
                    $t('message.pages.videoPlayerPixels.hrefHowInstallPixel')
                  "
                >
                  <span
                    style="font-size: 12px"
                    class="body-bold-small neutral-30-base--text"
                  >
                    {{ $t('message.playerPage.playerTabs.learnMore') }}
                  </span>
                  <v-icon class="body-bold-small" size="12"
                    >mdi-open-in-new</v-icon
                  >
                </a>
              </div>

              <div class="mt-5"><span class="body-bold-base">Pixels</span></div>
              <v-col class="py-0">
                <v-row
                  class="justify-space-between py-2 my-0"
                  v-for="(pixel, index) in pixels"
                  :key="pixel.id"
                >
                  <div
                    v-if="pixel && pixel.type"
                    class="d-flex flex-wrap align-center hover-line"
                    style="gap: 16px; cursor: pointer"
                    @click="editPixel(pixel, index)"
                  >
                    <img :src="iconPixels[pixel.type]" alt="Pixel Icon" />
                    <span class="body-regular-small">{{
                      pixel.name || pixel.id
                    }}</span>
                  </div>
                  <div v-if="pixel && pixel.type" class="d-flex align-center">
                    <base-btn
                      v-if="!pixel.isBeingRemoved"
                      type="neutral"
                      class="panda-edit icon-neutral-40-light --pixel mr-2"
                      icon="panda-edit"
                      size="24"
                      color="neutral-light"
                      @click="editPixel(pixel, index)"
                    />
                    <v-menu
                      v-if="!pixel.isBeingRemoved"
                      min-width="150px"
                      offset-y
                      bottom
                      left
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <base-btn
                          type="neutral"
                          class="panda-menu-action --pixel"
                          v-bind="attrs"
                          v-on="on"
                          color="neutral-light"
                        />
                      </template>

                      <v-list dense>
                        <v-list-item>
                          <v-list-item-title
                            style="color: #f44336"
                            @click="handleRemovePixel(pixel, index)"
                          >
                            <span
                              class="body-regular-smaller"
                              style="color: #f44336"
                              >{{ $t('message.pages.video.remove') }}</span
                            >
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-progress-circular
                      v-if="pixel.isBeingRemoved"
                      class="mr-2"
                      indeterminate
                      color="primary"
                      size="22"
                      width="3"
                    ></v-progress-circular>
                  </div>
                </v-row>
              </v-col>
            </div>
            <base-btn
              type="secondary"
              size="small"
              @click="openModalPixel = true"
              class="mt-2"
            >
              <v-icon>mdi-plus</v-icon>
              {{ $t('message.pages.videoPlayerPixels.addPixel') }}
            </base-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <unsaved-changes-modal />
    <v-dialog
      :fullscreen="isMobileBreakpoint"
      v-model="openModalPixel"
      persistent
      width="800"
      @keydown="handleEvent"
    >
      <v-card
        style="display: flex; flex-direction: column"
        :min-height="isMobileBreakpoint ? '' : 600"
        dense
      >
        <div elevation="0" style="flex: 0; display: flex; padding: 16px 24px">
          <div>
            <v-toolbar-title class="body-bold-medium pt-3">
              {{ $t('message.pages.videoPlayerPixels.addPixel') }}
            </v-toolbar-title>
            <div
              :style="{
                display: isMobileBreakpoint ? 'grid' : 'flex',
                gap: '3px',
                alignItems: isMobileBreakpoint ? 'grid' : 'center',
              }"
            >
              <span class="body-regular-smaller color-description">
                {{ $t('message.pages.videoPlayerPixels.copyAndPasteCode') }}
              </span>
              <a
                target="_blank"
                type="secondary"
                style="font-size: 12px"
                :href="
                  $t('message.pages.videoPlayerPixels.hrefHowInstallPixel')
                "
              >
                <span class="body-bold-smaller">
                  {{ $t('message.pages.videoPlayerPixels.learnInstallMore') }}
                </span>
                <v-icon class="body-bold-small" size="12"
                  >mdi-open-in-new</v-icon
                >
              </a>
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-icon
              color="neutral-70"
              @click="
                resetPixelForm()
                openModalPixel = false
              "
              >mdi-close</v-icon
            >
          </v-toolbar-items>
        </div>

        <div
          class="pa-6"
          :style="{
            height: isMobileBreakpoint ? '64vh' : '',
            minHeight: '57vh',
            maxHeight: '63vh',
            overflow: 'auto',
          }"
        >
          <h3 class="body-bold-base">
            {{ $t('message.pages.videoPlayerPixels.selectPlatform') }}
          </h3>
          <v-sheet
            :style="{
              display: !isMobileBreakpoint ? 'flex' : 'grid',
              justifyContent: !isMobileBreakpoint ? 'space-between' : '',
            }"
            class="mx-auto mt-4"
          >
            <span class="body-regular-small">
              {{ $t('message.pages.videoPlayerPixels.platform') }}</span
            >
            <v-chip-group v-model="platform" show-arrows>
              <v-chip
                class="px-9"
                :class="{ 'v-chip--active': isActiveFbPixelBtn }"
                style="width: 115px; margin-right: 0px !important"
                @click="togglePlatform('fbPixel')"
              >
                Meta
              </v-chip>
              <v-chip
                :class="{ 'v-chip--active': isActiveGooglePixelBtn }"
                style="width: 115px"
                class="mx-2 gtagIds-chip"
                value="gtagIds"
                @click="togglePlatform('gtagIds')"
              >
                GoogleAds
              </v-chip>
              <v-chip
                :class="{ 'v-chip--active': isActiveCustomPixelBtn }"
                min-width="115px"
                class="custom-chip"
                @click="togglePlatform('custom')"
              >
                {{ $t('message.pages.videoPlayerPixels.platforms.custom') }}
              </v-chip>
            </v-chip-group>
          </v-sheet>
          <div>
            <v-row v-if="isActiveCustomPixelBtn" class="mt-4" no-gutters>
              <v-col>
                <span class="body-regular-small">{{
                  $t('message.pages.videoPlayerPixels.placeholders.name')
                }}</span>
              </v-col>
              <v-col>
                <v-textarea
                  v-model="pixelData.name"
                  @blur="validateName"
                  :error-messages="errorMessage"
                  :placeholder="
                    $t('message.pages.videoPlayerPixels.labels.namePixel')
                  "
                  class="mt-0"
                  type="text"
                  outlined
                  no-resize
                  rows="1"
                />
              </v-col>
            </v-row>
            <v-row
              v-if="isActiveCustomPixelBtn"
              class="align-center"
              no-gutters
            >
              <v-col>
                <span class="body-regular-small">
                  {{ $t('message.pages.videoPlayerPixels.labels.type') }}</span
                >
              </v-col>
              <v-col>
                <v-select
                  :value="pixelData.conditionType"
                  dense
                  hide-details
                  :placeholder="
                    $t('message.pages.videoPlayerPixels.placeholders.select')
                  "
                  :items="typeCustomPixel"
                  item-text="label"
                  item-value="id"
                  @change="toggleTypeCustomPixel"
                >
                </v-select>
              </v-col>
            </v-row>
            <v-row
              v-if="
                isActiveCustomPixelBtn &&
                pixelData.conditionType == 'percentage'
              "
              class="align-center mt-2"
              no-gutters
            >
              <v-col>
                <span class="body-regular-small">{{
                  $t('message.pages.videoPlayerPixels.types.percentage')
                }}</span>
              </v-col>
              <v-col class="mt-2">
                <v-slider
                  hide-details
                  :max="100"
                  :step="1"
                  :value="pixelData.conditionValue"
                  @input="updateCustomValue"
                  class="d-flex align-center"
                >
                  <template v-slot:append>
                    <v-text-field
                      style="width: 60px"
                      class="pixelsPage__field--percentage"
                      outlined
                      :placeholder="'0'"
                      @keydown="restrictToNumbers"
                      :value="pixelData.conditionValue"
                      @input="updateCustomValue"
                      hide-details
                      max="100"
                      min="0"
                      :maxlength="3"
                    >
                      <template #message="{ message }">
                        <v-icon
                          color="red"
                          size="14"
                          class="iptMessage__error--icon"
                        >
                          mdi-alert-circle
                        </v-icon>
                        <span class="red--text">
                          {{ message }}
                        </span>
                      </template>
                    </v-text-field>
                  </template>
                </v-slider>
              </v-col>
            </v-row>
            <v-row
              v-if="
                isActiveCustomPixelBtn && pixelData.conditionType == 'absolute'
              "
              class="align-center mt-2"
              no-gutters
            >
              <v-col>
                <span class="body-regular-small">{{
                  $t('message.pages.videoPlayerPixels.types.absolute')
                }}</span>
              </v-col>
              <v-col
                class="mt-2"
                style="display: flex; justify-content: flex-end"
              >
                <AntTimePicker
                  class="hide-icon-time-picker"
                  v-if="
                    pixelData.conditionType === 'absolute' &&
                    !loadings.loadingConditionValueIpt
                  "
                  style="margin-bottom: 26px"
                  :startVal="String(pixelData.conditionValue)"
                  :timeVideo="timeVideo"
                  @changedTime="handleEndTimeEvent"
                />
              </v-col>
            </v-row>
            <v-divider
              v-if="
                isActiveFbPixelBtn ||
                isActiveGooglePixelBtn ||
                isActiveCustomPixelBtn
              "
              class="my-7"
            ></v-divider>
            <h3
              v-if="
                isActiveFbPixelBtn ||
                isActiveGooglePixelBtn ||
                isActiveCustomPixelBtn
              "
              class="body-bold-base mb-6"
            >
              Pixel
            </h3>
            <v-row
              v-if="isActiveFbPixelBtn || isActiveGooglePixelBtn"
              no-gutters
            >
              <v-col>
                <v-textarea
                  label="ID"
                  v-model="pixelData.id"
                  :placeholder="
                    isActiveGooglePixelBtn
                      ? $t(
                          'message.pages.videoPlayerPixels.placeholders.id.gtagIds'
                        )
                      : $t(
                          'message.pages.videoPlayerPixels.placeholders.id.fbPixel2'
                        )
                  "
                  class="text-input-pixel mt-0"
                  type="text"
                  dense
                  outlined
                  rows="1"
                  no-resize
                  hide-details="auto"
                  :error-messages="errorMessage"
                  @keydown="setIDPixel"
                  @blur="validateField"
                />
              </v-col>
            </v-row>
            <v-row v-if="isActiveCustomPixelBtn" no-gutters>
              <v-col>
                <v-textarea
                  :label="$t('message.commom.code')"
                  @keydown="setIDPixel"
                  v-model="pixelData.script"
                  @blur="validateScript"
                  :error-messages="errorMessageScript"
                  :placeholder="
                    $t(
                      'message.pages.videoPlayerPixels.placeholders.insertCode'
                    )
                  "
                ></v-textarea>
              </v-col>
            </v-row>
          </div>
        </div>
        <v-divider></v-divider>
        <v-card-actions class="px-6 pt-6 pb-6 justify-space-around">
          <v-spacer v-if="!isMobileBreakpoint"></v-spacer>
          <base-btn
            type="tertiary"
            @click="
              resetPixelForm()
              openModalPixel = false
            "
            :style="{ width: isMobileBreakpoint ? '100%' : 'auto' }"
          >
            {{ $t('message.cancel') }}
          </base-btn>
          <base-btn
            :style="{ width: isMobileBreakpoint ? '100%' : 'auto' }"
            class="ml-5"
            elevation="0"
            :loading="loading"
            :disabled="
              errorMessage !== '' ||
              errorMessageScript !== '' ||
              (pixelData.id == '' && pixelData.type !== 'custom') ||
              (pixelData.type == 'custom' && pixelData.script == '') ||
              (pixelData.type == 'custom' && pixelData.name == '') ||
              loading
            "
            @click="publishPixel"
          >
            {{ $t('message.pages.videoPlayerPixels.publish') }}
          </base-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import UnsavedChangesModal from '@/components/UnsavedChangesModal.vue'
import _ from 'lodash'
import i18n from '@/translations/lang'
import videosApi from '@/services/videosApi.js'
import { mapState, mapActions, mapMutations } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import MetaLogo from '@/assets/pandaIcons/metaLogo.svg'
import GoogleAdsLogo from '@/assets/pandaIcons/googleAdsLogo.svg'
import CustomPixelLogo from '@/assets/pandaIcons/customPixel.svg'
import AntTimePicker from '@/components/AntTimePicker.vue'
export default {
  name: 'VideoPlayerPixels',
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
    hasEdit: {
      type: Array,
    },
  },
  components: {
    UnsavedChangesModal,
    AntTimePicker,
  },
  computed: {
    ...mapState({
      videoInner: (state) => state.video,
      video: (state) => state.video.video,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),

    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
    fbPixelArr: {
      get() {
        return this.fbPixel
      },
      cache: false,
      deep: true,
    },
    gAnalyticsArr: {
      get() {
        return this.gtagIds
      },
      deep: true,
      cache: false,
    },
  },
  watch: {
    'pixelData.gtagId': {
      handler() {
        if (this.hasSomethingChanged() && this.pixelData.gtagId !== '') {
          this.withoutChanges = false
        } else {
          this.withoutChanges = true
        }
      },
    },
    'pixelData.pixelId': {
      handler() {
        if (this.hasSomethingChanged() && this.pixelData.pixelId !== '') {
          this.withoutChanges = false
        } else {
          this.withoutChanges = true
        }
      },
    },
    'pixelData.name': {
      handler() {
        if (this.hasSomethingChanged() && this.pixelData.script !== '') {
          this.withoutChanges = false
        } else {
          this.withoutChanges = true
        }
      },
    },
    'pixelData.script': {
      handler() {
        if (this.hasSomethingChanged() && this.pixelData.name !== '') {
          this.withoutChanges = false
        } else {
          this.withoutChanges = true
        }
      },
    },
  },
  data: () => ({
    indexBeingEdited: 0,
    isPixelsFormValid: true,
    loading: false,
    pixelsList: [],
    isEditing: false,
    withoutChanges: true,
    timeVideo: 0,
    pixels: [],
    platform: '',
    openModalPixel: false,
    requiredFieldRule: [],
    // pixelData: {},
    gtagIds: [],
    fbPixel: [],
    isActiveFbPixelBtn: false,
    isActiveGooglePixelBtn: false,
    isActiveCustomPixelBtn: false,
    errorMessage: '',
    errorMessageScript: '',
    showPercentage: false,
    pixelToBeEditedInitial: {},
    iconPixels: {
      fbPixel: MetaLogo,
      gtagIds: GoogleAdsLogo,
      custom: CustomPixelLogo,
    },
    pixelData: {
      id: '',
      type: '',
      name: '',
      conditionType: '',
      conditionValue: 0,
      script: '',
    },
    typeCustomPixel: [
      {
        label: i18n.t('message.pages.videoPlayerPixels.types.percentage'),
        id: 'percentage',
      },
      {
        label: i18n.t('message.pages.videoPlayerPixels.types.absolute'),
        id: 'absolute',
      },
      {
        label: i18n.t('message.pages.videoPlayerPixels.types.view'),
        id: 'view',
      },
      {
        label: i18n.t('message.pages.videoPlayerPixels.types.play'),
        id: 'play',
      },
    ],
    pixelToBeEditedDefault: {
      name: '',
      id: '',
      pixelId: '',
      gtagId: '',
      type: 'fbPixel',
      script: '',
      conditionValue: 0,
      conditionType: 'absolute',
    },
    profileId: '',
    eventTimeTypes: ['percentage', 'absolute', 'play', 'view'],
    pixelsTypes: ['fbPixel', 'gtagIds', 'custom'],
    loadings: {
      updatingPixel: false,
      loadingConditionValueIpt: false,
    },
    listIcons: {
      fbPixel: 'mdi-facebook',
      gtagIds: 'mdi-google',
      custom: 'mdi-xml',
    },
    articleLinks: {
      pt: 'https://help.pandavideo.com/pt-br/article/como-configurar-os-seus-pixels-14ybymo',
      en: 'https://help.pandavideo.com/en-us/article/how-to-configure-your-pixels-1fesu9c',
    },
  }),
  mounted() {
    this.gtagIds = this.videoInner.profile.vsl.gtagIds
    this.fbPixel = this.videoInner.profile.vsl.fbPixel
    this.pixels = this.video.config?.customPixels
      ? this.video.config?.customPixels
      : []
    console.log(this.pixels)
    this.$root.$on('discardChangesPixelsPage', () => {
      this.resetData()
      return (this.isEditing = false)
    })
    this.$root.$on('changeLanguage', () => {
      this.typeCustomPixel = [
        {
          label: i18n.t('message.pages.videoPlayerPixels.types.percentage'),
          id: 'percentage',
        },
        {
          label: i18n.t('message.pages.videoPlayerPixels.types.absolute'),
          id: 'absolute',
        },
        {
          label: i18n.t('message.pages.videoPlayerPixels.types.view'),
          id: 'view',
        },
        {
          label: i18n.t('message.pages.videoPlayerPixels.types.play'),
          id: 'play',
        },
      ]
    })
    this.resetData()
    this.timeVideo = this.$store.state.video.video?.length
    this.profileId = this.$store.state.video.video.config?.profile
    this.handleThreatGenerics()
    this.handleUpdatePixelsList()
    this.initPixel()
    this.isEditing = this.pixelsList.length === 0
    this.hasEdit.push(!this.hasSomethingChanged)
  },
  methods: {
    ...mapActions('video', [
      'updateProfile',
      'createProfile',
      'setProfileToVideos',
    ]),
    ...mapMutations('user', [
      'UPDATE_GLOBAL_SNACKBAR',
      'UPDATE_USER_PANDA_BRANDING_STATE',
      'UPDATE_USER_LOGO_BONUS',
    ]),
    ...mapMutations('video', ['UPDATE_VSL_FB', 'UPDATE_VSL_GOOGLE']),
    unmask(text) {
      const defaultDelimiters = /[-!$%^&*()_+|~=`{}[\]:";'<>?,./\\ ]/
      return text
        ? String(text).replace(new RegExp(defaultDelimiters, 'g'), '')
        : text
    },
    togglePlatform(platform, isOpenEdit) {
      if (!isOpenEdit)
        this.pixelData = {
          id: '',
          type: '',
          name: '',
          conditionType: '',
          conditionValue: '0',
          script: '',
        }

      this.pixelData.type = platform
      this.platform = platform
      this.errorMessageScript = ''
      switch (platform) {
        case 'fbPixel':
          this.isActiveFbPixelBtn = true
          this.isActiveGooglePixelBtn = false
          this.isActiveCustomPixelBtn = false
          break
        case 'gtagIds':
          this.isActiveFbPixelBtn = false
          this.isActiveGooglePixelBtn = true
          this.isActiveCustomPixelBtn = false
          break
        default:
          this.isActiveFbPixelBtn = false
          this.isActiveGooglePixelBtn = false
          this.isActiveCustomPixelBtn = true
      }
    },
    getListingTitle(pixel) {
      if (pixel.name) return pixel.name
      if (pixel.pixelId) return pixel.pixelId
      if (pixel.gtagId) return pixel.gtagId
      return ''
    },
    handleGoToArticle() {
      const articleLink =
        this.articleLinks[this.$i18next.resolvedLanguage] ??
        this.articleLinks['en']
      window.open(articleLink, '_blank')
    },
    handleThreatGenerics() {
      this.UPDATE_VSL_FB(this.getStrippedValue(this.fbPixelArr))
      this.UPDATE_VSL_GOOGLE(this.getStrippedValue(this.gAnalyticsArr))
    },
    getStrippedValue(value) {
      if (value) {
        if (typeof value === 'string') {
          return [value]
        }
        if (Array.isArray(value)) {
          return value
        }
      }
      return []
    },
    handleEvent(event) {
      const e = event
      if (e.key) {
        e.key === 'Escape' && this.handleClose()
      }
      return
    },
    handleUpdatePixelsList() {
      this.pixelsList = [
        ...this.pixelsList,
        ...this.prepareOldAanalyticsData(this.fbPixelArr, 'fbPixel'),
        ...this.prepareOldAanalyticsData(this.gAnalyticsArr, 'gtagIds'),
      ]
    },
    prepareOldAanalyticsData(arr, type) {
      if (typeof arr === 'string') {
        if (arr) {
          return [arr]
        } else {
          return []
        }
      }
      if (arr.length) {
        return arr.map((item) => {
          const model = _.cloneDeep(this.pixelToBeEditedDefault)
          if (type === 'fbPixel') {
            model.pixelId = item
          } else {
            model.gtagId = item
          }
          model.type = type
          return model
        })
      }
      return arr
    },
    hasSomethingChanged() {
      const initial = _.cloneDeep(this.pixelToBeEditedInitial)
      const current = _.cloneDeep(this.pixelData)

      if (
        initial.conditionType === current.conditionType &&
        initial.conditionValue !== current.conditionValue &&
        initial.conditionType === 'absolute'
      ) {
        let initialConditionValue = this.checkPureConditionValues(initial)
        let currentConditionValue = this.checkPureConditionValues(current)
        initial.conditionValue = initialConditionValue
        current.conditionValue = currentConditionValue
      }

      if (
        initial.type !== current.type &&
        !initial.id &&
        !initial.gtagId &&
        !initial.pixelId
      ) {
        initial.type = current.type
      }

      const currentValue =
        current.type === 'fbPixel'
          ? current.pixelId
          : current.type === 'gtagIds'
          ? current.gtagId
          : current.script ?? current.name

      return currentValue && !_.isEqual(initial, current)
    },
    checkPureConditionValues(val) {
      if (typeof val.conditionValue === 'string') {
        if (val.conditionValue.includes(':')) {
          return this.formatTimeToSeconds(val.conditionValue)
        } else {
          return val.conditionValue
        }
      }
      return val.conditionValue
    },
    publishEditPixel(pixel, index) {
      this.pixels[index] = pixel
      this.setPixelValue()
    },
    editPixel(pixel, index) {
      this.togglePlatform(pixel.type, true)
      this.indexPixel = index
      this.pixelData = pixel
      this.checkConditionValue()
      this.openModalPixel = true
    },
    removePixel(index) {
      this.pixels.splice(index, 1)
      this.setPixelValue()
      this.checkChanges()
      this.indexPixel = null
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        type: 'success',
        text: i18n.t('message.pages.videoPlayerPixels.toastRemovedPixel'),
      })
    },
    setIdPixel() {
      if (this.pixelData.type == 'fbPixel')
        this.pixelData.pixelId = this.pixelData.id
      if (this.pixelData.type == 'gtagIds')
        this.pixelData.gtagId = this.pixelData.id
    },
    async publishPixel() {
      this.loading = true
      this.validateField()
      this.validateScript()
      this.validateName()
      this.setIdPixel()
      await this.checkProfile()
      if (this.validateField() || this.validateScript()) {
        this.loading = false
        return
      }
      if (this.indexPixel == 0 || this.indexPixel)
        this.publishEditPixel(this.pixelData, this.indexPixel)
      else this.pixels.push({ ...this.pixelData })
      this.setPixelValue()
      if (this.pixelData.type !== 'custom') {
        const controls = this.$store.state.video.profile.controls
        const colors = this.$store.state.video.profile.colors
        const vsl = this.$store.state.video.profile.vsl
        vsl['fbPixel'] = this.fbPixel
        vsl['gtagIds'] = this.gtagIds
        await this.updateProfile([
          this.profileId,
          {
            controls: controls,
            colors: colors,
            vsl: vsl,
          },
        ])
        this.UPDATE_VSL_FB(this.fbPixel)
        this.UPDATE_VSL_GOOGLE(this.gtagIds)
      } else {
        if (!this.indexPixel && this.indexPixel !== 0)
          this.indexPixel = this.pixels.length - 1
        this.handlePublishCustom()
      }

      this.resetPixelForm()
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        type: 'success',
        text: i18n.t('message.pages.videoPlayerPixels.toastAddPixel'),
      })
      this.openModalPixel = false
      this.isActiveFbPixelBtn = false
      this.isActiveGooglePixelBtn = false
      this.isActiveCustomPixelBtn = false
      this.loading = false
    },
    handleEditPixel(pixel, index = this.pixelsList.length) {
      this.indexBeingEdited = index
      if (![...arguments].length) {
        this.isEditing = true
      } else {
        this.pixelData = _.cloneDeep(pixel)
        this.pixelToBeEditedInitial = _.cloneDeep(pixel)
        this.isEditing = true
      }
      this.checkConditionValue()
    },
    checkConditionValue() {
      if (this.pixelData.conditionType === 'absolute') {
        this.pixelData.conditionValue = this.formatSecondsToTime(
          this.pixelData.conditionValue
        )
      }
    },
    formatSecondsToTime(seconds) {
      if (!seconds) return '00:00'
      if (typeof seconds == 'string') return seconds
      let res = new Date(seconds * 1000).toISOString()
      if (this.timeVideo < 3600) {
        return res.substring(14, 19)
      }
      return res.substring(11, 19)
    },
    formatTimeToSeconds(time) {
      if (!time) return 0
      let res = time.split(':').reduce((acc, time) => 60 * acc + +time)
      return res
    },
    resetData() {
      this.pixelData = _.cloneDeep(this.pixelToBeEditedDefault)
      this.pixelToBeEditedInitial = _.cloneDeep(this.pixelToBeEditedDefault)
    },
    initPixel() {
      const gtagIds = this.gtagIds.map((gtagIds) => {
        return {
          id: gtagIds,
          type: 'gtagIds',
          gtagId: gtagIds,
          conditionType: '',
          name: gtagIds,
        }
      })
      const fbPixel = (this.fbPixel || []).map((fbPixel) => {
        return {
          id: fbPixel,
          type: 'fbPixel',
          pixelId: fbPixel,
          conditionType: '',
          name: fbPixel,
        }
      })
      this.pixels = [...this.pixels, ...gtagIds, ...fbPixel]
    },
    setPixelValue() {
      this.fbPixel = this.pixels
        .filter((pixel) => pixel.type == 'fbPixel' || pixel.type == 'meta')
        .map((pixel) => {
          return this.unmask(pixel.id)
        })
      this.gtagIds = this.pixels
        .filter((pixel) => pixel.type == 'gtagIds' || pixel.type == 'googleAds')
        .map((pixel) => {
          return pixel.id
        })
      this.customPixels = this.pixels
        .filter((pixel) => pixel.type == 'custom')
        .map((pixel) => {
          return {
            name: pixel.name,
            script: this.getScriptWithoutScriptTag(pixel.script),
            conditionType: pixel.conditionType,
            conditionValue: pixel.conditionValue,
            id: pixel.id ? pixel.id : uuidv4(),
          }
        })
    },
    async handleRemovePixel(pixel, index) {
      this.pixels[index].isBeingRemoved = true
      this.pixels = [...this.pixels]
      if (pixel.type !== 'custom') {
        let newPixelsList = []
        if (pixel.type === 'fbPixel' || pixel.type === 'meta') {
          const index = this.fbPixelArr.indexOf(pixel.id)
          this.fbPixelArr.splice(index, 1)
          newPixelsList = _.cloneDeep(this.pixels).filter(
            ({ pixelId }) => pixelId !== pixel.pixelId
          )
        } else if (pixel.type === 'gtagIds' || pixel.type == 'googleAds') {
          const index = this.gAnalyticsArr.indexOf(pixel.id)
          this.gAnalyticsArr.splice(index, 1)
          newPixelsList = _.cloneDeep(this.pixels).filter(
            ({ gtagId }) => gtagId !== pixel.gtagId
          )
        }

        await this.handlePublishGenerics(true)
        this.pixels = newPixelsList
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          type: 'success',
          text: i18n.t('message.pages.videoPlayerPixels.toastRemovedPixel'),
        })
        return
      }
      const newPixelsList = _.cloneDeep(this.pixels).filter(
        (row) => row.id !== pixel.id && row.type == 'custom'
      )
      await videosApi.setPlayerPixel(this.video.id, newPixelsList)
      this.pixels = _.cloneDeep(this.pixels).filter(
        (row) => row.id !== pixel.id
      )
      this.video.config.customPixels = this.pixels.filter(
        (pixel) => pixel.type == 'custom'
      )
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        type: 'success',
        text: i18n.t('message.pages.videoPlayerPixels.toastRemovedPixel'),
      })
    },

    getConditionValue() {
      if (this.pixelData.conditionType === 'percentage') {
        return this.pixelData.conditionValue
      } else if (this.pixelData.conditionType === 'absolute') {
        return this.getConditionAbsoluteSecondsValue()
      }
    },
    getConditionAbsoluteSecondsValue() {
      let seconds
      if (typeof this.pixelData.conditionValue === 'string') {
        seconds = this.formatTimeToSeconds(this.pixelData.conditionValue)
      } else {
        seconds = this.pixelData.conditionValue
      }
      return seconds
    },
    getScriptWithoutScriptTag() {
      this.pixelData.script = this.pixelData.script
        ?.replaceAll('<script>', '')
        ?.replaceAll(`<\/script>`, '') // eslint-disable-line
      return this.pixelData.script
    },
    resetPixelForm() {
      this.isActiveFbPixelBtn = false
      this.isActiveGooglePixelBtn = false
      this.isActiveCustomPixelBtn = false
      this.errorMessage = ''
      this.errorMessageScript = ''
      this.pixelData = {
        id: '',
        type: '',
        name: '',
        conditionType: '',
        conditionValue: 0,
        script: '',
      }
      this.indexPixel = null
      this.platform = ''
    },
    async handlePublishCustom() {
      try {
        let name = this.pixelData.name
        if (!this.pixelData.name && this.pixelData.type !== 'custom') {
          if (this.pixelToBeEditedInitial.type === 'fbPixel') {
            name = this.pixelData.pixelId
          } else {
            name = this.pixelData.gtagId
          }
        }
        const pixelObj = {
          name,
          script: this.getScriptWithoutScriptTag(),
          conditionType: this.pixelData.conditionType,
          conditionValue: this.getConditionValue(),
          id: this.pixelData.id ? this.pixelData.id : uuidv4(),
          type: this.pixelData.type,
        }
        this.pixels[this.indexPixel] = pixelObj
        const listToBePosted = this.pixels.filter(
          (item) => item.type === 'custom'
        )
        const res = await videosApi.setPlayerPixel(
          this.video.id,
          listToBePosted
        )
        this.video.config.customPixels = res.data.customPixels || []
      } catch (err) {
        console.error(err)
      }
    },
    async checkProfile() {
      if (!this.video.config.profile) {
        const { data } = await this.createProfile(this.video.id)
        this.video.config.profile = data.id
        this.profileId = data.id
        await this.setProfileToVideos([this.profileId, this.video.id])
      }
    },
    restrictToNumbers(event) {
      const allowedKeys = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'Backspace',
        'Tab',
        'ArrowLeft',
        'ArrowRight',
        'Delete',
      ]
      if (!allowedKeys.includes(event.key)) {
        event.preventDefault()
      }
    },
    updateCustomValue(value) {
      let parsedValue = Math.min(100, Math.max(0, Number(value)))

      this.pixelData.conditionValue = parsedValue
    },
    loadCurrentPixelOnGenerics() {
      if (this.pixelData.type === 'fbPixel') {
        const index = this.fbPixelArr.indexOf(
          this.pixelToBeEditedInitial.pixelId
        )
        if (index !== -1) {
          this.fbPixelArr[index] = this.pixelData.pixelId
        } else {
          this.fbPixelArr.push(this.pixelData.pixelId)
        }
      } else if (this.pixelData.type === 'gtagIds') {
        const index = this.gAnalyticsArr.indexOf(
          this.pixelToBeEditedInitial.gtagId
        )
        if (index !== -1) {
          this.gAnalyticsArr[index] = this.pixelData.gtagId
        } else {
          this.gAnalyticsArr.push(this.pixelData.gtagId)
        }
      }
    },
    async handlePublishGenerics(isReplacing = false) {
      try {
        await this.checkProfile()
        if (!isReplacing) this.loadCurrentPixelOnGenerics()

        const controls = this.$store.state.video.profile.controls
        const colors = this.$store.state.video.profile.colors
        const vsl = this.$store.state.video.profile.vsl

        vsl['fbPixel'] = this.fbPixelArr.filter((el) => el !== '')
        vsl['gtagIds'] = this.gAnalyticsArr.filter((el) => el !== '')
        await this.updateProfile([
          this.profileId,
          {
            controls: controls,
            colors: colors,
            vsl: vsl,
          },
        ])
        if (!isReplacing) this.addCurrentGenericToTheList()
      } catch (e) {
        console.error(e)
      }
    },
    addCurrentGenericToTheList() {
      const pixelObj = _.cloneDeep(this.pixelToBeEditedDefault)
      pixelObj.type = this.pixelData.type
      if (pixelObj.type === 'fbPixel') {
        pixelObj.pixelId = this.pixelData.pixelId
      } else {
        pixelObj.gtagId = this.pixelData.gtagId
      }
      this.pixelsList[this.indexBeingEdited] = pixelObj
    },
    async validateForm() {
      this.requiredFieldRule = [
        (v) => {
          if (typeof v === 'number') {
            if (v >= 0) {
              return true
            }
            return false
          }
          return !!v || i18n.t('message.requiredFieldMessage')
        },
      ]
      await this.$refs.pixelsForm.validate()
    },
    validateField() {
      if (!this.pixelData.id && this.pixelData.type !== 'custom') {
        this.errorMessage = this.$t('message.requiredField')
        return true
      } else {
        this.errorMessage = ''
        return false
      }
    },
    validateScript() {
      if (this.pixelData.type == 'custom' && this.pixelData.script == '') {
        this.errorMessageScript = this.$t('message.requiredField')
        return true
      } else {
        this.errorMessageScript = ''
        return false
      }
    },
    validateName() {
      if (this.pixelData.type == 'custom' && this.pixelData.name == '') {
        this.errorMessageScript = this.$t('message.requiredField')
        return true
      } else {
        this.errorMessageScript = ''
        return false
      }
    },
    setIDPixel() {
      this.errorMessage = ''
      this.unsavedChanges = true
    },
    checkCondition(value) {
      return this.pixelData.conditionType == value
    },
    toggleTypeCustomPixel(type) {
      this.handleChangePixelTimeMode(type)
      this.pixelData.conditionType = type
      this.showPercentage = true
    },
    async submitPixel() {
      // await this.validateForm()

      // if (!this.isPixelsFormValid) return
      this.loadings.updatingPixel = true

      if (this.pixelData.type === 'custom') {
        this.pixelData.conditionValue = parseInt(this.pixelData.conditionValue)
        await this.handlePublishCustom()
      } else {
        await this.handlePublishGenerics()
      }

      if (
        this.pixelToBeEditedInitial.type !== this.pixelData.type &&
        (this.pixelToBeEditedInitial.id ||
          this.pixelToBeEditedInitial.pixelId ||
          this.pixelToBeEditedInitial.gtagId)
      ) {
        if (this.pixelToBeEditedInitial.type === 'custom') {
          // when it was Custom and now is FB
          const listToBePosted = this.pixelsList.filter(
            (item) =>
              item.id !== this.pixelToBeEditedInitial.id &&
              item.type === 'custom'
          )
          await videosApi.setPlayerPixel(this.video.id, listToBePosted)
        } else {
          // when it was FB and now is Custom
          let updateGenerics = false
          if (this.pixelToBeEditedInitial.type === 'fbPixel') {
            const index = this.fbPixelArr.indexOf(
              this.pixelToBeEditedInitial.pixelId
            )
            if (index !== -1) {
              this.fbPixelArr.splice(index, 1)
              updateGenerics = true
            }
          } else if (this.pixelToBeEditedInitial.type === 'gtagIds') {
            let index = this.gAnalyticsArr.indexOf(this.pixelData.gtagId)
            if (index !== -1) {
              this.gAnalyticsArr.splice(index, 1)
              updateGenerics = true
            }
          }
          if (updateGenerics) await this.handlePublishGenerics(true)
        }
      } else if (this.pixelData.type === 'custom') {
        await this.handlePublishGenerics(true)
      }

      this.loadings.updatingPixel = false
      this.handleGetBack(true)
    },
    handleGetBack(forceExit = false) {
      if (this.hasSomethingChanged() && !forceExit) {
        if (this.isEditing) {
          this.$root.$emit('unsavedChangesModal', false, false, false, true)
          this.$root.$emit('updateEmbedPreviewChange')
          return
        }
      }
      if (this.isEditing && (forceExit || this.pixelsList.length !== 0)) {
        this.resetData()
        return (this.isEditing = false)
      }
      this.handleBack()
    },
    handleChangePixelType(type) {
      this.pixelData.type = type
      this.$refs.pixelsForm.reset()
    },
    handleEndTimeEvent(timeString) {
      this.pixelData.conditionValue = this.formatTimeToSeconds(timeString)
    },
    async handleChangePixelTimeMode(timeType) {
      if (timeType !== this.pixelData.conditionType) {
        this.loadings.loadingConditionValueIpt = true
        if (
          timeType === 'percentage' &&
          this.pixelData.conditionType === 'absolute'
        ) {
          let seconds = this.getConditionAbsoluteSecondsValue()
          if (!seconds) {
            this.pixelData.conditionValue = 0
          } else {
            this.pixelData.conditionValue = Math.round(
              (seconds / this.timeVideo) * 100
            )
          }
        } else if (
          timeType === 'absolute' &&
          this.pixelData.conditionType === 'percentage'
        ) {
          this.pixelData.conditionValue = this.formatSecondsToTime(
            Math.round((this.pixelData.conditionValue * this.timeVideo) / 100)
          )
        }
        this.loadings.loadingConditionValueIpt = false
      }
      this.$nextTick(() => {
        this.pixelData.conditionType = timeType
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.embed-textarea .v-text-field__slot {
  margin: 0 -47px 4px 0 !important;
}
.typesText {
  font-size: 11px;
}
.icon-neutral-40-light {
  color: varFigma(neutral-40-light);
}
.text-input-pixel::v-deep {
  & .v-input__control .v-text-field__details {
    padding: 0 !important;
  }
}
.thumbnailTimePicker {
  margin-bottom: 0px;
}
.color-back {
  color: varFigma(brand-60-base);
}
.color-description {
  color: varFigma(neutral-40-light);
}
::v-deep .v-list-item {
  cursor: pointer;
  transition: background-color 0.3s;
}
::v-deep .v-text-field__slot .v-label {
  margin-left: -10px;
}
::v-deep .v-list-item:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
::v-deep .v-list-item.theme--dark:hover {
  background-color: #292b35 !important;
}
::v-deep .v-input--selection-controls__input {
  margin-right: 0px !important;
}
v-list-item-title.disabled-v-list-item-title {
  color: varFigma(neutral-70) !important;
}
.disabled-v-list-item {
  cursor: not-allowed;
}
.hide-icon-time-picker {
  width: 52px;
}
::v-deep .hide-icon-time-picker > .ant-time-picker-icon {
  display: none;
}
::v-deep .v-chip {
  margin-right: 0;
}
.base-button.--pixel {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  padding: 0 !important;
  width: 30px !important;
  height: 30px !important;
}
</style>

<style>
.pixelsPage__field--percentage .v-text-field__slot::after {
  position: absolute;
  color: varFigma(neutral-40-light) !important;
  right: 0.5em;
  transition: all 0.05s ease-in-out;
  content: '%';
}
.pixelsPage__field--percentage .v-text-field__slot {
  margin-right: 0px;
}
.pixelsPage__field--percentage .v-input__control .v-input__slot {
  padding-right: 2px !important;
}
.pixelsPage__field--percentage .v-text-field__slot:hover::after,
.pixelsPage__field--percentage .v-text-field__slot:focus-within::after {
  /* right: 1.5em; */
}
.hover-line {
}
</style>
